// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:wght@200&display=swap);"]);
// Module
exports.push([module.id, ".message {\n    position: fixed;\n    bottom: 7%;\n    left: 45%;\n    background: #212121;\n    border-radius: 7px;\n    width: 100px;\n    border: 7px solid #212121;\n}\n\n.message h1 {\n    font-family: Nunito;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 14px;\n    text-align: center;\n    margin: auto;\n    color: #FFFFFF;\n}\n\n@media screen and (max-width: 600px) {\n    .message {\n        left: 16%;\n    }\n}", ""]);
// Exports
module.exports = exports;
